@if (loaded) {
  <div class="modal-scss">
    @if (mode === 'table') {
      <section>
        <div class="p-fluid mb-2">
          <div class="d-flex align-items-center justify-content-between">
            <div class="w-100">
              <span class="p-input-icon-left ms-auto w-100">
                <i class="pi pi-search"></i>
                <input
                  autofocus
                  pInputText
                  class="w-100"
                  type="text"
                  (input)="dt.filterGlobal($event.target.value, 'contains')"
                  [placeholder]="'editCourrier.searchRecipientByNameOrAddress' | translate" />
              </span>
            </div>
          </div>
        </div>
        <div class="restrictHeight60vh">
          <p-table
            #dt
            [value]="contacts | removeEmptyLabel: 'label' | sort: 'label' : 'ASC'"
            styleClass="p-datatable-striped"
            [scrollable]="true"
            [totalRecords]="contacts.length"
            [globalFilterFields]="['label', 'adresse']"
            [(selection)]="chosenRecipient"
            selectionMode="single"
            dataKey="value">
            <ng-template pTemplate="header" let-columns>
              <tr>
                @for (col of contactsColumns; track col; let i = $index) {
                  <th [id]="col.field">{{ col.header }}</th>
                }
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr [pSelectableRow]="rowData">
                <td>{{ rowData['label'] }}</td>
                <td>{{ rowData['adresse'] }}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <i-button [text]="'cancel' | translate" styleClass="bottomButton red mb-3" (click)="onClose()"></i-button>
        <i-button [text]="'confirm' | translate" styleClass="bottomButton green" (click)="onSubmit()"> </i-button>
      </section>
    }
    @if (mode === 'autocomplete') {
      <section>
        <div class="p-fluid mb-2">
          <p-autoComplete
            autofocus
            id="expediteursAutocompleteSearch"
            styleClass="w-100"
            type="search"
            field="label"
            dataKey="value"
            [panelStyle]="{ display: 'none' }"
            [emptyMessage]="'noResultFound' | translate"
            [placeholder]="'pleaseSelectASender' | translate"
            [suggestions]="suggestions"
            (completeMethod)="searchSenderAutoComplete($event)"
            (onClear)="clearAutocomplete()">
            <ng-template let-selectedItem pTemplate="selectedItem"> {{ selectedItem.label }} </ng-template>
          </p-autoComplete>
        </div>
        <div class="restrictHeight60vh_overflowXAuto">
          <div class="mb-2">
            @if (displayAlertNotEnoughtLetters) {
              <section>
                <div class="alert alert-info">{{ 'modals.pleaseWriteAtLeastThreeLetters' | translate }}</div>
              </section>
            }
            @if (!displayAlertNotEnoughtLetters) {
              <section>
                @if (!contacts.length) {
                  <div class="alert alert-info">{{ 'noContactFound' | translate }}</div>
                }
                @if (contacts.length) {
                  <p-table
                    #dt
                    [value]="contacts | removeEmptyLabel: 'label' | sort: 'label' : 'ASC'"
                    styleClass="p-datatable-striped"
                    [totalRecords]="contacts.length"
                    [(selection)]="chosenRecipient"
                    selectionMode="single"
                    dataKey="value">
                    <ng-template pTemplate="header" let-columns>
                      <tr>
                        @for (col of contactsColumnsWithType; track col; let i = $index) {
                          <th [id]="col.field">{{ col.header }}</th>
                        }
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                      <tr [pSelectableRow]="rowData">
                        <td>{{ rowData['label'] }}</td>
                        <td>{{ rowData['nameTypeContact'] }}</td>
                        <td>{{ rowData['adresse'] }}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                }
              </section>
            }
          </div>
        </div>
        <i-button [text]="'cancel' | translate" styleClass="bottomButton red mb-3" (click)="onClose()"></i-button>
        <i-button [text]="'confirm' | translate" styleClass="bottomButton green" (click)="onSubmit()"> </i-button>
      </section>
    }
  </div>
}
@if (!loaded) {
  <div class="loader_div">
    <i-loader [size]="100" [text]="'loading' | translate"></i-loader>
  </div>
}
